import { HomeMatchDashboardRow } from "generated/openApi";
import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import ApiService from "services/apiService";

interface MatchDataContextValue {
    pieChartRows: HomeMatchDashboardRow[] | undefined;
    tableRows: HomeMatchDashboardRow[] | undefined;
    reportDateFrom: Date | undefined;
    reportDateTo: Date | undefined;
    loading: boolean;
    refetch: () => void;
}

const MatchDataContext = createContext<MatchDataContextValue | undefined>(undefined);

interface MatchDataProviderProps {
    children: ReactNode;
}

export const MatchDataProvider = ({ children }: MatchDataProviderProps) => {
    const [pieChartRows, setPieChartRows] = useState<HomeMatchDashboardRow[] | undefined>(undefined);
    const [tableRows, setTableRows] = useState<HomeMatchDashboardRow[] | undefined>(undefined);
    const [reportDateFrom, setReportDateFrom] = useState<Date | undefined>(undefined);
    const [reportDateTo, setReportDateTo] = useState<Date | undefined>(undefined);   
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        fetch();
    }, []);

    const fetch = () => {
        setLoading(true);
        ApiService.home.getMatchDashboard().then((response) => {
            setPieChartRows(response.pieChartRows);
            setTableRows(response.tableRows);
            setReportDateFrom(response.reportDateFrom);
            setReportDateTo(response.reportDateTo);
            setLoading(false);
        }).catch((error) => {
            console.error("Failed to fetch match dashboard:", error);
            setLoading(false);
        });
    };

    const value: MatchDataContextValue = {
        pieChartRows,
        tableRows,
        reportDateFrom,
        reportDateTo,
        loading,
        refetch: fetch,
    };

    return (
        <MatchDataContext.Provider value={value}>
            {children}
        </MatchDataContext.Provider>
    );
};

export const useMatchData = (): MatchDataContextValue => {
    const context = useContext(MatchDataContext);
    if (context === undefined) {
        throw new Error("useMatchData must be used within a MatchDataProvider");
    }
    return context;
};